/* eslint-disable max-lines-per-function */
import { useState } from 'react';
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Command, CommandGroup, CommandItem } from '@/components/ui/command';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarStar } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';

export function CalendarSelect() {
  const { t } = useTranslation();
  const { kalender, selectedKalenderIds, setSelectedKalenderIds } =
    useCalendarContext();
  const [localSelection, setLocalSelection] =
    useState<string[]>(selectedKalenderIds);

  function handleOpenChange() {
    setLocalSelection(selectedKalenderIds);
  }

  function handleSelect(kalenderId: string) {
    if (localSelection.includes(kalenderId)) {
      setLocalSelection(localSelection.filter((id) => id !== kalenderId));
    } else {
      setLocalSelection([...localSelection, kalenderId]);
    }
  }

  function handleConfirm() {
    setSelectedKalenderIds(localSelection);
  }

  return (
    <Drawer onOpenChange={handleOpenChange}>
      <DrawerTrigger asChild>
        <Button variant="subtle" size="icon">
          <FontAwesomeIcon icon={faCalendarStar} />
        </Button>
      </DrawerTrigger>
      <DrawerContent className="flex flex-col">
        <DrawerHeader className="pb-0">
          <DrawerTitle className="text-sm text-center text-neutrals-N900 font-semibold">
            {t('domain.termine.terminCalendar')}
          </DrawerTitle>
          <DrawerDescription className="sr-only">
            {t('domain.termine.terminCalendar')}
          </DrawerDescription>
        </DrawerHeader>
        <div className="flex-1 px-4" data-vaul-no-drag>
          <Command>
            <CommandGroup>
              {kalender.map((kalenderItem) => (
                <CommandItem
                  className="transition-colors text-sm font-normal"
                  key={kalenderItem.id}
                  value={kalenderItem.name}
                  onSelect={() => handleSelect(kalenderItem.id)}>
                  <div className="flex justify-between items-center w-full">
                    <span>{kalenderItem.name}</span>
                    <Checkbox
                      checked={localSelection.includes(kalenderItem.id)}
                    />
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </Command>
        </div>
        <div className="p-4 flex-shrink-0">
          <DrawerClose asChild>
            <Button className="w-full" size="lg" onClick={handleConfirm}>
              {t('domain.termine.form.fertig')}
            </Button>
          </DrawerClose>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
